import { Role, RoleEnum, PageEditorRoleKeysEnum, AllFrameworksRole, AllEvidenceDataRole, PageViewerRoleEnum, DefaultEvidenceRoles } from '@anecdotes/api-contracts';

export const staticRoles: Role[] = [
  {
    key: RoleEnum.Admin,
    name: 'userManagement.roles.admin',
    description: 'userManagement.inviteUser.adminRoleDescription',
    extends: [
      PageEditorRoleKeysEnum.MyAnecdotesEditorRole,
      PageEditorRoleKeysEnum.PolicyManagerEditorRole,
      PageEditorRoleKeysEnum.RiskManagerEditorRole,
      PageEditorRoleKeysEnum.PluginsEditorRole,
      PageEditorRoleKeysEnum.SettingsEditor,
      PageEditorRoleKeysEnum.PlaybooksEditor,
      PageEditorRoleKeysEnum.UarEditorRole,
      PageEditorRoleKeysEnum.TrustCenterEditor,
      PageEditorRoleKeysEnum.DashboardEditorRole,
      AllFrameworksRole,
      AllEvidenceDataRole,
      PageViewerRoleEnum.TrustCenterAccessManager,
      PageEditorRoleKeysEnum.EvidenceLabEditorRole,
      ...DefaultEvidenceRoles
    ],
    permissions: [],
  },
  {
    key: RoleEnum.Manager,
    name: 'userManagement.roles.manager',
    description: 'userManagement.inviteUser.collaboratorRoleDescription',
    extends: [
      PageEditorRoleKeysEnum.MyAnecdotesEditorRole,
      PageEditorRoleKeysEnum.PolicyManagerEditorRole,
      PageEditorRoleKeysEnum.RiskManagerEditorRole,
      PageEditorRoleKeysEnum.PluginsEditorRole,
      PageEditorRoleKeysEnum.UarEditorRole,
      PageEditorRoleKeysEnum.PlaybooksEditor,
      PageEditorRoleKeysEnum.EvidenceLabEditorRole,
      PageEditorRoleKeysEnum.DashboardEditorRole,
      AllFrameworksRole,
      AllEvidenceDataRole,
      ...DefaultEvidenceRoles
    ],
  },
  {
    key: RoleEnum.It,
    name: 'userManagement.roles.it',
    description: 'userManagement.inviteUser.itRoleDescription',
    extends: [PageEditorRoleKeysEnum.PluginsEditorRole, PageEditorRoleKeysEnum.SettingsEditor],
    permissions: [],
  },
  {
    key: RoleEnum.TrustCenterAccessManager,
    name: 'userManagement.roles.trustCenterAccessManager',
    description: 'userManagement.inviteUser.trustCenterAccessManagerDescription',
    extends: [PageViewerRoleEnum.TrustCenterAccessManager],
    permissions: [],
  },
  {
    key: RoleEnum.Auditor,
    name: 'userManagement.roles.auditor',
    description: 'userManagement.inviteUser.auditorRoleDescription',
    extends: [AllFrameworksRole, AllEvidenceDataRole],
    permissions: [],
  },
];
